import type { ProfileResponse } from 'entities/user/types';

export const hasFullName = (profile: ProfileResponse | null | undefined): boolean =>
  Boolean(profile?.first_name?.trim() && profile?.last_name?.trim());
